module.exports = __webpack_public_path__ + "img/icon-come-back.c2582bcc.svg";